// Shared Links catalog — used by both the classic Links page (Links.jsx) and the
// ribbon sidebar's Links panel (RibbonSidebar.jsx). Every link opens in a new tab
// (these are external sites; most forbid being embedded in a frame).

export const GROUPS = [
  {
    label: 'Apps & Productivity',
    links: [
      { name: 'DocuSign', url: 'https://apps.docusign.com/',    desc: 'E-signature & agreements',       tone: '#9C7A2F' },
      { name: 'Adobe',    url: 'https://account.adobe.com/',    desc: 'Adobe account & Creative Cloud', tone: '#A23A2E' },
      { name: 'Zoom',     url: 'https://zoom.us/',              desc: 'Video meetings',                 tone: '#2D6B9C' },
      { name: 'Asana',    url: 'https://app.asana.com/',        desc: 'Project & task management',      tone: '#993C57' },
      { name: 'KnowBe4',  url: 'https://training.knowbe4.com/', desc: 'Security awareness training',    tone: '#C06A2A' }
    ]
  },
  {
    label: 'Internal Systems',
    links: [
      { name: 'CAAM HVAC',     url: 'http://hvac.caam.local/login',       desc: 'Building HVAC control panel',          tone: '#9C6A2F' },
      { name: 'NetFacilities', url: 'https://system.netfacilities.com/',  desc: 'Facilities management & work orders', tone: '#7A5430' },
      { name: 'UniFi Network', url: 'https://unifi.ui.com/',              desc: 'Ubiquiti network controller',          tone: '#3D5D7A' }
    ]
  },
  {
    label: 'DGS / State of California',
    links: [
      { name: 'DGS Shared Services', url: 'https://dgs.service-now.com/dgs_ssp',                                                                                                                                  desc: 'DGS ticketing & service portal (ServiceNow)', tone: '#2B5F3F' },
      { name: 'CMAS Search',         url: 'https://cmassearch-prod.apps.dgs.ca.gov/',                                                                                                                              desc: 'California Multiple Award Schedules',         tone: '#3D6B4F' },
      { name: 'Cal eProcure',        url: 'https://caleprocure.ca.gov/pages/index.aspx',                                                                                                                           desc: 'State procurement portal',                    tone: '#4A6B3D' },
      { name: 'DGS Training',        url: 'https://dgs.geniussis.com/PublicWelcome.aspx',                                                                                                                          desc: 'DGS learning management (GeniusSIS)',         tone: '#5C6B3D' },
      { name: 'NCB Request',         url: 'https://dgs.service-now.com/ncb?id=ticket&is_new_order=true&table=sc_req_item&sys_id=513a17934788a2d073486435f16d43dc',                                                  desc: 'Non-Competitive Bid request form',            tone: '#6B5D3D' },
      { name: 'FI$Cal',              url: 'https://fiscal.ca.gov/access-fiscal/',                                                                                                                                  desc: 'State financial system access',               tone: '#3D4D6B' }
    ]
  },
  {
    label: 'Microsoft / Collaboration',
    links: [
      { name: 'CAAM SharePoint', url: 'https://cawater.sharepoint.com/sites/cnra-cio/iso/California%20African%20American%20Museum%20%203105/Forms/AllItems.aspx', desc: 'Shared department files', tone: '#1F4B7A' }
    ]
  },
  {
    label: 'Vendor Tools',
    links: [
      { name: 'Tenable Cloud', url: 'https://cloud.tenable.com/tio/app.html#/login', desc: 'Vulnerability scanning & security', tone: '#3D2F5C' },
      { name: 'Miro',          url: 'https://miro.com/',                            desc: 'Visual collaboration & whiteboards', tone: '#7A5C2F' }
    ]
  }
];
